export default __webpack_public_path__ + "static/media/Arbitrum.8dac5fdd.svg";